import { Paper, Typography, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import RemoveIcon from '@material-ui/icons/Remove';

const style = makeStyles((theme) => ({
  paper: {
    height: "50px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "center",
    padding: "10px",
    border: "1px solid gray",
  },
  paperActive: {
    height: "50px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "center",
    padding: "10px",
    border: "1px solid gold",
  },
  deleteIcon: {
    marginLeft: "10px",
    height: "28px",
    width: "28px",
  },
  ActiveDeleteIcon: {
    marginLeft: "10px",
    height: "28px",
    width: "28px",
    color: "red",
  },
  line: {
    height: "28px",
    width: "28px",
  },
  lineName: {
    display: "flex",
    alignItems: "center",
  },
  name: {
    fontSize: "14px",
    fontWeight: 600,
  },
}));

export const ScrollElement = ({
  dataKey,
  stroke,
  setLine,
  hendleMutateData,
}) => {
  const classes = style();

  const [active, setActive] = useState(false);
  const [activeElement, setActiveElement] = useState(false);

  const handleOver = (e) => {
    e.stopPropagation();
    setActive(true);
  };
  const handleOut = (e) => {
    e.stopPropagation();
    setActive(false);
  };

  const handleOverElement = (e) => {
    e.stopPropagation();
    setActiveElement(true);
  };
  const handleOutElement = (e) => {
    e.stopPropagation();
    setActiveElement(false);
  };

  const handleDelete = (event) => {
    event.stopPropagation();
    setLine((prev) => {
      return prev.filter((line) => line.dataKey !== dataKey);
    });
  };

  return (
    <React.Fragment>
      <Paper
        className={activeElement ? classes.paperActive : classes.paper}
        onMouseOver={handleOverElement}
        onMouseOut={handleOutElement}
        onClick={() => {
          hendleMutateData(dataKey);
        }}
      >
        <div className={classes.lineName}>
          <RemoveIcon
            className={classes.line}
            style={{ color: stroke }}
          />
          <Typography className={classes.name}>{dataKey}</Typography>
        </div>
        <HighlightOffIcon
          className={active ? classes.ActiveDeleteIcon : classes.deleteIcon}
          onMouseOver={handleOver}
          onMouseOut={handleOut}
          onClick={handleDelete}
        />
      </Paper>
    </React.Fragment>
  );
};
